module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedBold.6aa840b.eot";